function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 13V4C17 2.89543 16.1046 2 15 2H5C3.89543 2 3 2.89543 3 4V16C3 17.1046 3.89543 18 5 18H13.5",
  stroke: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 5.5,
  y1: 5.5,
  x2: 13.5,
  y2: 5.5,
  stroke: "black",
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 5.5,
  y1: 8.5,
  x2: 13.5,
  y2: 8.5,
  stroke: "black",
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 5.5,
  y1: 11.5,
  x2: 9.64286,
  y2: 11.5,
  stroke: "black",
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 3,
  stroke: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.25 16.1875L15.8125 16.75L17.125 15.4375",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgOrder = function SvgOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/order.fa3a29e5.svg";
export { ForwardRef as ReactComponent };